/**
 * 数据表模板选择弹窗
 */
import {useEffect, useCallback, useRef, useState} from 'react';
import * as store from '@/store';
import sdk from '@/sdk';
import {DstTplDialogData} from '@/types/document/doc';
import {INotify} from '@/types/document/notification';
import {
    rteNotifyType,
    rteNotifyTemplateAction,
} from '@/constants/document/notification';
import {importAsyncComponent} from '@/utils/loadable';
const Dialog = importAsyncComponent(() => import('./Dialog'));

export interface IProps {
    dstTplDialogData?: DstTplDialogData;
    dstToken?: string;
    createDstLoding?: boolean;
}

const TemplateDialog: React.FC<IProps> = (props) => {
    const {dstTplDialogData, dstToken, createDstLoding} = props;
    const {visible, successCb} = dstTplDialogData as DstTplDialogData;
    const prevDstLodingRef = useRef(false); // 记录上一次的表夹创建 loading 状态
    const [isError, setIsError] = useState(false); // 是否必备字段缺失，导致页面渲染失败

    // 创建表夹 loading 由 true 转为 false 时，代表完成创建
    const isFinishCreate = prevDstLodingRef.current && !createDstLoding;

    useEffect(() => {
        prevDstLodingRef.current = createDstLoding as boolean;
    });

    const getDstToken = useCallback(async () => {
        try {
            const token = await sdk.getDstToken();
            if (token) {
                setIsError(false);
            } else {
                setIsError(true);
            }
        } catch (e) {
            setIsError(true);
        }
    }, []);

    useEffect(() => {
        if (!dstToken && visible) {
            getDstToken();
        }
    }, [dstToken, getDstToken, visible]);

    const handleRetry = useCallback(() => {
        getDstToken();
    }, [getDstToken]);

    const handleClose = useCallback(() => {
        store.setDstTplDialogData({
            visible: false,
        });
    }, []);

    useEffect(() => {
        if (isFinishCreate) {
            handleClose();
        }
    }, [isFinishCreate, handleClose]);

    const handleApplyTemplate = (templateId?: string) => {
        successCb && successCb(templateId || '');
    };

    // 处理RTE的通知
    const handleRteNotify = async (data: INotify) => {
        // 线上问题判断依据 请兄弟姐妹们一定不要删Thanks♪(･ω･)ﾉ
        console.info('模板收到RTE通知，数据是:', data); // 用于调试
        const {type, action} = data;

        // 关闭模板弹窗
        if (type === rteNotifyType.CLOSE) {
            if (action === rteNotifyTemplateAction.CLOSE_TEMPLATE_MODAL) {
                handleClose();
            }
        }

        // 根据模板创建数据表夹
        if (type === rteNotifyType.CREATE) {
            // 空模板
            if (action === rteNotifyTemplateAction.CREATE_NEW) {
                handleApplyTemplate();
            }

            // 某个模板
            if (action === rteNotifyTemplateAction.CREATE_BY_TEMPLATE) {
                const templateId = data?.data?.nodeId || '';
                handleApplyTemplate(templateId);
            }
        }
    };

    return (
        visible ?
            <Dialog
                visible={visible}
                dstToken={dstToken}
                isError={isError}
                isLoading={createDstLoding}
                onClose={handleClose}
                onRetry={handleRetry}
                onRteNotify={handleRteNotify}
            /> : null
    );
};


export default store.connect([
    store.KEYS.DST_TPL_DIALOG_DATA,
    store.KEYS.DST_TOKEN,
    store.KEYS.CREATE_DST_LOADING,
])(TemplateDialog);
